import { onKey } from "../lib/shortcuts/onKey.js";
import {
  APP_LANGUAGE_ENGLISH,
  APP_LANGUAGE_HEBREW
} from "../lib/settings/appSettings.js";

export function getNextRecoveryLanguage(activeLanguage) {
  return activeLanguage === APP_LANGUAGE_HEBREW
    ? APP_LANGUAGE_ENGLISH
    : APP_LANGUAGE_HEBREW;
}

export function createDatabaseErrorPageShortcuts({
  activeLanguage = APP_LANGUAGE_ENGLISH,
  handleLanguageChange = null
} = {}) {
  return [
    onKey(
      "Alt+L",
      () => {
        if (!handleLanguageChange) {
          return;
        }

        return handleLanguageChange(getNextRecoveryLanguage(activeLanguage));
      },
      { allowInInput: true }
    )
  ];
}
